import { useEffect, useState } from "react";
import DemoCard from "./demo-card";
import { useNavigate, NavLink } from "react-router-dom";
import Button from "./button";
import axiosInstance from "../axios";

export default function DemoTutors({ showText = true, isDemoPage = false }) {
  const [isMobile, setIsMobile] = useState(false);
  const [activeContainer, setActiveContainer] = useState();
  const [tutorsData, setTutorsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  let _dealData = JSON.parse(localStorage.getItem("dealData"));
  const userId = JSON.parse(localStorage.getItem("userDetails")).userId;
  useEffect(() => {
    // Comment out API call for demo purposes
    setLoading(true);
    let dealId = _dealData.id;

    if (!isDemoPage) {
      axiosInstance
        .get(`v1/cre/student/recommendation/process-for-student?dealings_id=${dealId}&page=1&limit=2500`)
        .then(response => {
          setActiveContainer(() => "Demo");
          if (response.data.data) {
            setTutorsData(() => response.data.data.data?.filter(item => item.status !== "CONFIRMED"));
          }
        })
        .catch(err => {
          // console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      axiosInstance
        .get(`v1/cre/student/recommendation/process-for-student?page=1&limit=2500`)
        .then(response => {
          const Status = ["DEMO_SCHEDULED", "ASSIGNED", "CANCELLED"];
          setActiveContainer(() => "Demo");
          if (response.data.data) {
            setTutorsData(() =>
              response.data.data.data
                .filter(item => Status.includes(item.status))
                .map(element => ({
                  ...element,
                  status: element.status.replace("_", " "),
                })),
            );
          }
        })
        .catch(err => {
          // console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    setActiveContainer("Demo");
    setIsMobile(() => window.innerWidth <= 768);
  }, [userId]);

  const makeTitle = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}>
        <div className="loading">
          <img src="./book-loader.gif" alt="Loading..." />
        </div>
      </div>
    );
  }

  return tutorsData?.length != 0 ? (
    <div className="demo-tutors--container">
      {!isMobile && (
        <div className="demo-tutors--container--nav-wrapper">
          {/* <div  onClick={()=>{setActiveContainer(()=>'Demo')}} className={`${(activeContainer=='Demo')?'active-btn':'unactive-btn'}`}>Assigned Tutor For Demo</div> */}
          {/* <div  onClick={()=>{setActiveContainer(()=>'Demo')}} className={`${(activeContainer=='Demo')?'active-btn':'unactive-btn'}`}>Demo</div> */}
          {/* <div className={`${(activeContainer=='Tried')?'active-btn':'unactive-btn'}`} onClick={()=>{setActiveContainer(()=>'Tried')}}>Tried</div>
            <div className={`${(activeContainer=='Shortlisted')?'active-btn':'unactive-btn'}`} onClick={()=>{setActiveContainer(()=>'Shortlisted')}}>Shortlisted</div> */}
        </div>
      )}

      {!isMobile && showText && (
        <section className="pathway-requestBtn--wrapper">
          <div className="pathway--wrapper">
            <div
              onClick={() => {
                navigate("/dashboard");
              }}>
              <img src="/homeicon.svg" alt="homeicon icon" width="18" height="17" />
            </div>
            <div>
              <img src="/rightArrow.svg" alt="rightArrow icon" width="11" height="11" />
            </div>
            <div className="pathway--btn">Demo Tutors</div>
          </div>
          <div className="request-btn--wrapper">
            <NavLink to="/new-request">
              <Button>New Request</Button>
            </NavLink>
          </div>
        </section>
      )}

      <div className="demo-tutors--cards--wrapper">
        {tutorsData?.map(data => {
          return (
            <div className="demo-tutors--card--wrapper" key={data.id}>
              {showText && (
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span
                    className="demo-tutors--card--title"
                    style={{
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      fontStyle: "SemiBold",
                      fontSize: 24,
                      letterSpacing: 0,
                    }}>
                    Requirement: {data.student_requirments}
                  </span>
                  <span
                    className="demo-tutors--card--subtitle"
                    style={{
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      fontStyle: "SemiBold",
                      fontSize: 24,
                      letterSpacing: 0,
                      color: "#2B93A5",
                    }}>
                    Request ID : {data.id}
                  </span>
                </div>
              )}
              <DemoCard data={data} />
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    <div
      style={{
        color: "rgba(130, 130, 130, 1)",
        fontSize: "14px",
        fontWeight: "600",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      No Tutors Assigned to you
    </div>
  );
}
